export const isFileEmpty = fileSize => fileSize === 0;
export const isMaxFileSize = fileSize => fileSize >= 5242880; // 5MB
export const emptyFileMessage = 'File is empty!';
export const maxFileMessage = 'File size should be 5MB or less';



// WEBPACK FOOTER //
// ./src/actions/website/FileUploadActionsUtil.js